"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Container = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = _interopRequireDefault(require("../../theme"));
var _IconDynamicArrow = _interopRequireDefault(require("../Icon/IconDynamicArrow"));
const _excluded = ["children", "width", "component", "className", "direction", "icon"];
const Text = _styledComponents.default.span.withConfig({
  shouldForwardProp: prop => ['direction'].indexOf(prop) === -1
})`
  margin: ${({
  direction
}) => direction === 'right' ? '0 10px 0 0' : '0 10px'};
`;

// won't actually be a div, will be whatever 'component' is
const Container = exports.Container = _styledComponents.default.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${_theme.default.colors.black};
  font-weight: ${_theme.default.fontWeights.black};
  text-decoration: none !important;
  cursor: pointer;

  &:hover {
    a,
    ${Text} {
      color: ${_theme.default.textColors.link};
    }

    ${Text} svg path,
    ${Text} svg rect,
    svg.icon-dynamic-arrow path,
    svg.icon-dynamic-arrow rect {
      /* might not even want this.. makes svgs in children blue on hover */
      fill: ${_theme.default.textColors.link};
    }
  }
`;
const Content = ({
  children,
  width,
  direction,
  icon
}) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, direction === 'left' && /*#__PURE__*/_react.default.createElement(_IconDynamicArrow.default, {
  className: "icon-dynamic-arrow",
  width: width,
  direction: direction,
  viewBox: width ? `0 0 ${width} 16` : undefined
}), direction === 'right' && icon, /*#__PURE__*/_react.default.createElement(Text, {
  direction: direction
}, children), direction === 'right' && /*#__PURE__*/_react.default.createElement(_IconDynamicArrow.default, {
  className: "icon-dynamic-arrow",
  width: width,
  direction: direction,
  viewBox: width ? `0 0 ${width} 16` : undefined
}), direction === 'left' && icon);
Content.propTypes = {
  children: _propTypes.default.node,
  width: _propTypes.default.number,
  direction: _propTypes.default.string,
  icon: _propTypes.default.node
};
const ArrowLink = _ref => {
  let {
      children,
      width,
      component,
      className,
      direction,
      icon
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const LinkComponent = component;
  return /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
    className: className,
    as: LinkComponent
  }, others), /*#__PURE__*/_react.default.createElement(Content, {
    width: width,
    direction: direction,
    icon: icon
  }, children));
};
ArrowLink.defaultProps = {
  direction: 'right',
  width: 50
};
ArrowLink.propTypes = {
  width: _propTypes.default.number,
  children: _propTypes.default.node.isRequired,
  component: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  direction: _propTypes.default.string,
  icon: _propTypes.default.node
};
var _default = exports.default = ArrowLink;